import { codes as moduleCodes, data as moduleData, numbers as moduleNumbers } from 'currency-codes';

export const currencyCodes = () => moduleCodes().sort((a, b) => (a > b ? 1 : -1));
export const currencyNumbers = () => moduleNumbers().sort((a, b) => (a > b ? 1 : -1));
export const currencyData = moduleData.sort((a, b) => (a.currency > b.currency ? 1 : -1));

export const getCurrencyByCode = (code: string | null | undefined) => typeof code === 'string' ? moduleData.find((x) => x.code === code) : undefined;

export { code as currencyCode, number as currencyNumber, publishDate as currencyPublishDate } from 'currency-codes';
